var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-header"},[_c('span',{staticClass:"header-font"},[_vm._v("木棉树全息展示平台")])])}]

export { render, staticRenderFns }